export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 10;

export const SELECTED_ADVISOR = 'selectedAdvisor';
